import { useNavigate } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useTranslation } from "context/LanguageContext";

export default function OrderPageHeader({ title, navigation }) {
  const navigate = useNavigate();
  const { language } = useTranslation();
  const isRTL = language === "ar";
  const target = navigation === "back" ? "/orders" : "/";
  const accessibleLabel = navigation === "back" ? "Back to orders" : "Back to home";

  return (
    <div className="bg-white shadow-sm sticky top-0 z-10">
      <div className="w-full max-w-4xl mx-auto px-4 py-4">
        <div className={`flex items-center gap-3 sm:gap-4 ${isRTL ? "flex-row-reverse" : ""}`}>
          <button
            type="button"
            onClick={() => navigate(target)}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors flex-shrink-0"
            aria-label={accessibleLabel}
          >
            {isRTL ? (
              <IoIosArrowForward data-testid="back-arrow-rtl" className="w-5 h-5" />
            ) : (
              <IoIosArrowBack data-testid="back-arrow-ltr" className="w-5 h-5" />
            )}
          </button>
          <h1 className={`text-lg sm:text-xl lg:text-2xl font-semibold text-gray-800 truncate ${
            isRTL ? "text-right" : "text-left"
          }`}>
            {title}
          </h1>
        </div>
      </div>
    </div>
  );
}
